import { Inject, Injectable } from '@angular/core';
import { Routes } from '@angular/router';

import { Observable } from 'rxjs';
import { environment } from '../config/environment';
import { InjectedModule } from '../models/InjectedModuleModel/InjectedModule';


 import {HomeModule} from '../../home/home.module';

 import {LocalizationsModule} from '../../localizations/localizations.module';

 
 import { RolesModule } from '../../roles/roles.module';

 
 import { NotificationsModule } from '../../notifications/notifications.module';

 import { LookupsModule } from '../../lookups/lookups.module';
 
 import { DepartmentsModule } from '../../departments/departments.module';
 
 import { SectorsModule } from '../../sectors/sectors.module';

 import { ConfigurationsModule } from '../../configurations/configurations.module';

 
 import { ImpersonationRulesModule } from '../../impersonation-rules/impersonation-rules.module';

 import { JobsModule } from '../../jobs/jobs.module';

 
 import { LicenseModule } from '../../license/license.module';

 
 import { WorkflowsModule } from '../../workflows/workflows.module';

 
 import { PublicHolidaysModule } from '../../publicHolidays/public-holidays.module';

 import { HelpCenterModule } from '../../helpCenter/help-center.module';

 import { LogsModule } from '../../logs/logs.module';
 import { ProvidersModule } from '../../providers/providers.module';
import { AuthenticationModule } from '../../authentication/authentication.module';
import {UsersModule} from '../../users/users.module';
import { ActiveDirectoryModule } from '../../ActiveDirectories/active-directory.module';


@Injectable()
export class injectionModuleService {
    

  static  InjectedModules :InjectedModule[]=[]

  static  routesArray:Routes=
           
  [
     {
       path: '', redirectTo: 'Home', pathMatch: 'full'
     },
     {
       path: 'authentication', loadChildren:injectionModuleService.getAuthenticationModule
     },
  
     {
       path: 'Home', loadChildren:injectionModuleService.getHomeModule
     },
     {
       path: 'Users', loadChildren:injectionModuleService.getUsersModule
     }
     ,
     {
       path: 'Localization', loadChildren:injectionModuleService.getLocalizationsModule
     }
     ,
     {
       path: 'Roles', loadChildren:injectionModuleService. getRolesModule
     }
     ,
     {
       path: 'Notifications', loadChildren:injectionModuleService. getNotificationsModule
     }
     ,
     {
       path: 'Lookups', loadChildren:injectionModuleService. getLookupsModule
     }
     ,
     {
       path: 'Departments', loadChildren:injectionModuleService. getDepartmentsModule
     }
     ,
     {
       path: 'Sectors', loadChildren:injectionModuleService. getSectorsModule
     }
     ,
     {
       path: 'Configurations', loadChildren:injectionModuleService. getConfigurationsModule
     }
     ,
     {
       path: 'ImpersonationRules', loadChildren:injectionModuleService. getImpersonationRulesModule
     }
     ,
     {
       path: 'Jobs', loadChildren: injectionModuleService.getJobsModule
     }
  
     ,
     {
       path: 'License', loadChildren:injectionModuleService. getLicenseModule
     }
     ,
     {
       path: 'Workflows', loadChildren:injectionModuleService. getWorkflowsModule
     }
       ,
       {
         path: 'PublicHolidays', loadChildren:injectionModuleService. getPublicHolidaysModule
       } ,
       {
         path: 'HelpCenter', loadChildren:injectionModuleService. getHelpCenterModule
       },
       {
         path: 'Logs', loadChildren:injectionModuleService. getLogsModule
       },
       {
         path: 'Providers', loadChildren:injectionModuleService. getProvidersModule
      },
      {
        path: 'ADConnection', loadChildren: injectionModuleService.getActiveDirectoryModule
      },

      
    
  ]

   static injectNewModules(InjectedModules:InjectedModule[]){
    injectionModuleService.InjectedModules=InjectedModules
    for (let index = 0; index < injectionModuleService.InjectedModules.length; index++) {
      const InjectedModule = injectionModuleService.InjectedModules[index];
      injectionModuleService.routesArray.push({path:InjectedModule.routeName,loadChildren:InjectedModule.module})
    }
   }

   static  getProvidersModule() {
    return ProvidersModule;
  }
 

  static  getAuthenticationModule() {
    return AuthenticationModule;
   }
   
   static  getLogsModule() {
    return LogsModule;
  }

  static  getHelpCenterModule() {
    return HelpCenterModule;
  }

  static  getPublicHolidaysModule() {
    return PublicHolidaysModule;
  }
  static  getWorkflowsModule() {
    return WorkflowsModule;
   }
   static  getLicenseModule() {
    return LicenseModule;
   }
  static getJobsModule() {
     return JobsModule;
   }
   static  getImpersonationRulesModule() {
    return ImpersonationRulesModule;
   }
   
   static  getHomeModule() {
    return HomeModule;
   }
   
   static  getUsersModule() {
    return UsersModule;
   }
   
   static  getLocalizationsModule() {
    return LocalizationsModule;
   }
   static  getRolesModule() {
    return RolesModule;
   }
   static  getNotificationsModule() {
    return NotificationsModule;
   }
   static  getLookupsModule() {
    return LookupsModule;
   }
   static  getDepartmentsModule() {
    return DepartmentsModule;
   }
   static  getSectorsModule() {
    return SectorsModule;
   }
   static  getConfigurationsModule() {
    return ConfigurationsModule;
  }
  static getActiveDirectoryModule() {
    return ActiveDirectoryModule;
   }
}
